export type ModuleId = "agents" | "leads" | "content" | "quote" | "answer";

export interface ModuleMetadata {
  id: ModuleId;
  label: string;
  description: string;
  basePath: string;
}

export const MODULES: ModuleMetadata[] = [
  {
    id: "agents",
    label: "Agents",
    description: "Configure and run AI agents",
    basePath: "/agents",
  },
  {
    id: "leads",
    label: "Leads",
    description: "Capture and convert inbound leads",
    basePath: "/leads",
  },
  {
    id: "content",
    label: "Content",
    description: "Create and schedule AI-generated content",
    basePath: "/content",
  },
  {
    id: "quote",
    label: "Quote",
    description: "AI quote desk: drafts queue, documents, follow-up sequences",
    basePath: "/quote",
  },
  {
    id: "answer",
    label: "Answer",
    description: "AI questionnaire drafting: KB upload, RAG drafts with citations, library",
    basePath: "/answer",
  },
];

/**
 * Module access for the current user.
 *
 * **2026-05-08 simplification:** all modules are visible to every logged-in
 * user. The credits-model paywall (M1) gates resource consumption — without
 * an active Stripe subscription, dispatch refuses to spend credits — so
 * per-module visibility gating is no longer load-bearing for monetization.
 *
 * Previous behavior read `user.publicMetadata.modules.{leads,content}` from
 * Clerk and required an admin to flip the toggle in the Clerk Dashboard
 * before the Leads / Content tabs would appear. That dance is gone.
 *
 * The function still takes its arguments (and stays exported) so existing
 * call sites and the `<ModuleGuard>` component compile untouched.
 */
export function hasModuleAccess(_metadata: unknown, _moduleId: ModuleId): boolean {
  return true;
}
